import React, { Component } from 'react';

class App extends Component {
  render() {
    const { children } = this.props;

    return <article>{children}</article>;
  }
}

export default App;
